import type { AccountSnapshot, PlatformId, PostMetric } from "../types";
import { PLATFORMS } from "./platforms";

export interface MetricsPullContext {
  since?: string;
}

export interface MetricsPullResult {
  snapshot?: Omit<AccountSnapshot, "id" | "updatedAt" | "deletedAt">;
  posts?: Array<Omit<PostMetric, "id" | "updatedAt" | "deletedAt">>;
}

/**
 * Manual adapters never call a platform. A future X adapter can set `pull`
 * to read public post metrics. Do not wire a paid API here.
 */
export interface MetricsAdapter {
  platform: PlatformId;
  label: string;
  source: "manual" | "pull";
  pull?: (context: MetricsPullContext) => Promise<MetricsPullResult>;
}

export const xMetricsAdapter: MetricsAdapter = {
  platform: "x",
  label: "X",
  source: "pull",
};

export const metricsAdapters: MetricsAdapter[] = PLATFORMS.map((platform) =>
  platform.id === "x"
    ? xMetricsAdapter
    : {
        platform: platform.id,
        label: platform.label,
        source: "manual" as const,
      },
);

export function getMetricsAdapter(platform: PlatformId): MetricsAdapter {
  return metricsAdapters.find((item) => item.platform === platform) ?? {
    platform,
    label: platform,
    source: "manual",
  };
}
